import React, { useEffect, useState } from "react";

const TimePicker = ({ value = "", onChange,saveForm}) => {
  const parseTime = (timeStr) => {
    if (!timeStr) return { hour: "", minute: "", period: "" };
    const [time, period] = timeStr.split(" ");
    const [hour, minute] = time.split(":");
    return { hour, minute, period };
  };

  const [localTime, setLocalTime] = useState({
    hour: "",
    minute: "",
    period: ""
  });

  useEffect(() => {
    const parsed = parseTime(value);
    setLocalTime(parsed);
  }, [value]);

  const handleChange = (field, fieldValue) => {
    const updated = { ...localTime, [field]: fieldValue };
    setLocalTime(updated);
    const formattedTime = `${updated.hour}:${updated.minute} ${updated.period}`;
    onChange(formattedTime);
  };

  let hours = [...Array(12)].map((_, i) => String(i + 1).padStart(2, "0"));
  let minutes = [0, 15, 30, 45].map((m) => String(m).padStart(2, "0"));
  const periods = ["SELECT","AM", "PM"];
  hours=["SELECT",...hours];
  minutes=["SELECT",...minutes];
  return (
    <div className="flex gap-2 items-center">
      <select
        value={localTime.hour}
        onChange={(e) => handleChange("hour", e.target.value)}
        onBlur={saveForm} 
        className="border p-2 rounded"
      >
        {hours.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </select>

      <span>:</span>

      <select
        value={localTime.minute}
        onChange={(e) => handleChange("minute", e.target.value)}
        onBlur={saveForm} 
        className="border p-2 rounded"
      >
        {minutes.map((m) => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>

      <select
        value={localTime.period}
        onChange={(e) => handleChange("period", e.target.value)}
        onBlur={saveForm} 
        className="border p-2 rounded"
      >
        {periods.map((p) => (
          <option key={p} value={p}>
            {p}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TimePicker;
